<template>
  <div class="card bg-white max-w-sm mx-auto p-8 text-center">
    <h1 v-text="'Reset Account Access'" />
    <form
      class="form-horizontal mt-6"
      @submit.prevent="submit"
    >
      <div class="px-8 text-left">
        <label
          for="phone_number"
          v-text="'Mobile Number'"
        />
        <VuePhoneNumberInput
          id="phone_number"
          v-model="form.phone_number"
          name="phone_number"
          color="#064bc3"
          class="mb-4"
          :translations="{ phoneNumberLabel: 'Mobile Number' }"
          default-country-code="US"
          no-flags
          no-validator-state
          required
          @update="handlePhoneUpdate"
        />
        <span
          v-if="form.errors.has('phone_number')"
          class="help-block"
          v-text="form.errors.get('phone_number')"
        />
      </div>
      <div class="px-8 text-left">
        <SecurityQuestionField
          v-model="form.security.question"
          :questions="securityQuestions"
        />
        <div>
          <label
            for="security_answer"
            v-text="'Security Question Answer'"
          />
          <input
            id="security_answer"
            v-model="form.security.answer"
            name="security_answer"
            :class="{ error: form.errors.has('security.answer') }"
            type="text"
          >
          <span
            v-if="form.errors.has('security.answer')"
            class="help-block"
            v-text="form.errors.get('security.answer')"
          />
        </div>
      </div>
      <button
        type="submit"
        class="btn mt-8 my-4"
        :class="{ 'load': form.busy }"
        :disabled="form.busy"
        :aria-disabled="form.busy"
        v-text="'Save'"
      />
    </form>
    <ConfirmNumberModal
      :show="showConfirmNumberModal"
      :auth-code-id="authCodeId"
      message="Before we update your number please enter the 6 digit authorization code we just sent as a text message."
      @codeIsValid="handleValidCode"
      @cancel="handleCanceledCode"
    />
  </div>
</template>

<script type="text/babel">
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import MUMForm from 'Base/Resources/assets/js/MUMForm'
import SecurityQuestionField from './sms/SecurityQuestionField'
import ConfirmNumberModal from './ConfirmNumberModal'

export default {
  name: 'ResetSecurityQuestionForm',
  components: {
    ConfirmNumberModal,
    SecurityQuestionField,
    VuePhoneNumberInput,
  },
  props: {
    securityQuestions: {
      type: Array,
      required: true,
    },
    accountResetToken: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      authCodeId: '',
      showConfirmNumberModal: false,
      form: new MUMForm({
        confirmation: null,
        token: null,
        phone_number: null,
        phone_number_country: null,
        security: {
          question: '',
          answer: null,
        },
      }),
    }
  },
  async mounted() {
    await this.$nextTick()

    this.form.security.question = this.securityQuestions[0]
  },
  methods: {
    handleValidCode(confirmation) {
      this.form.confirmation = confirmation

      this.showConfirmNumberModal = false

      this.submit()
    },
    handleCanceledCode() {
      this.showConfirmNumberModal = false

      this.form.finishProcessing()

      this.$store.commit('baseAddNotification', {
        type: 'error',
        title: 'Error',
        text: 'Profile was not reset.',
      })
    },
    handlePhoneUpdate(data) {
      this.form.phone_number_country = data.countryCode
    },
    async submit() {
      this.form.errors.clear()

      this.form.token = this.token

      try {
        this.form.startProcessing()

        const { data } = await this.$api.public().post(`/account-reset/${this.accountResetToken}/reset`, this.form)

        if (data.status === 'sms_confirmation_required') {
          this.showConfirmNumberModal = true

          this.authCodeId = data.auth_code_id
        } else {
          window.location = `${data.redirect}?reset`
        }
      } catch (errors) {
        this.form.errors.set(errors.response.data)
      } finally {
        this.form.finishProcessing()
      }
    },
  },
}
</script>
